

























import { Vue, Component } from "vue-property-decorator";
import { GetNoticeResponse } from "@/typescript/api_client/emesh_api/notifications/types";
import { getNoticeApi } from "@/typescript/api_client/emesh_api/notifications/notice_api";
import { Moment } from "../../../typescript/lib/common/moment";
export { GetNoticeResponse };

// 一度に読み込むお知らせの件数
const NOTICE_LOAD_LIMIT: number = 10;

@Component
export default class NotificationPopupComponent extends Vue {
  //Data
  showPopup: boolean = false;
  notifications: GetNoticeResponse[] = [];
  loadCount: number = 0;

  //methods
  onClickShow(): void {
    if (!this.notifications.length) {
      this.getData();
    }
    this.showPopup = !this.showPopup;
  }

  getData(): void {
    // API に offset がないため、フロント側で押された回数を保持し、[押された回数 * 10件]としてお知らせ一覧を取得する
    this.loadCount++;
    getNoticeApi(this.loadCount * NOTICE_LOAD_LIMIT).then(
      (resp: GetNoticeResponse[]) => {
        this.notifications = resp.map(notice => {
          notice.created_datetime = Moment.convertApiDateTime(
            notice.created_datetime,
            "YYYY/MM/DD HH:mm"
          );
          return notice;
        });
      }
    );
  }

  //Computed
  get popupStyle() {
    return {
      display: this.showPopup ? "block" : "none"
    };
  }

  close() {
    this.showPopup = false;
  }
}
